const checkout = {
  state: () => ({
    country: {
      codeOrigin: 'us',
      code: window.localStorage.getItem('arcux_country') ? window.localStorage.getItem('arcux_country') : 'us',
      label: 'Perú',
    },

    paymentMethod: 'visa',

    product: {
      type: 'course',
      data: {},

      isLoading: true,
    },

    price: {
      current: {
        name: '',
        plan: '',
        slug: '',
        amount: {
          original: 0,
          discount: 0,
          final: 0,
          paid: 0,
          currency: '',
        },
      },
      convertions: {},

      isDisabled: false,
      isLoading: true,
    },

    coupon: {
      try: false,
      enable: false,
      code: {
        value: '',
        isValid: false,
      },

      current: null,
      convertions: {},

      isLoading: false,
    },
  }),
  mutations: {
    updateCountry(state, payload) {
      state.country = payload;
    },
    updateProduct(state, payload) {
      state.product = payload;
    },
    updatePrice(state, payload) {
      state.price = payload;
    },
    updatePaymentMethod(state, payload) {
      state.paymentMethod = payload;
    },
    updateCoupon(state, payload) {
      state.coupon = payload;
    },
  },
  actions: {
    updateCountry(context, payload) {
      context.commit('updateCountry', payload);
    },
    updateProduct(context, payload) {
      context.commit('updateProduct', payload);
    },
    updatePrice(context, payload) {
      context.commit('updatePrice', payload);
    },
    updatePaymentMethod(context, payload) {
      context.commit('updatePaymentMethod', payload);
    },
    updateCoupon(context, payload) {
      context.commit('updateCoupon', payload);
    },
  },
};

export default checkout;
